import { FETCHING_NOTIFICATION_SUCCESS, FETCHING_START } from '../actions/actiontypes'

export default function(state = [], action) {
	switch(action.type){
		case FETCHING_START:{
			return [];
		}
		case FETCHING_NOTIFICATION_SUCCESS:{
			return [...state, ...action.payload];
		}
		default:
			return state;
	}
}